import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RequestDepartment, CreateRequestDepartmentDto, UpdateRequestDepartmentDto, GetRequestDepartmentsParams, RequestDepartmentEdition } from '../models/request-department.model';

@Injectable({
    providedIn: 'root',
})
export class RequestDepartmentService {
    private baseUrl = `${environment.API_GATEWAY_URL}/request-v2/admin/request-department`;

    constructor(private http: HttpClient) {}

    getRequestDepartments(params?: GetRequestDepartmentsParams): Observable<RequestDepartment[]> {
        return this.http.get<RequestDepartment[]>(this.baseUrl, { params: params as any });
    }

    getRequestDepartmentById(id: string): Observable<RequestDepartment> {
        return this.http.get<RequestDepartment>(`${this.baseUrl}/${id}`);
    }

    getRequestDepartmentByIdEdition(id: string): Observable<RequestDepartmentEdition> {
        return this.http.get<RequestDepartmentEdition>(`${this.baseUrl}/${id}/edition`);
    }

    createRequestDepartment(data: CreateRequestDepartmentDto): Observable<RequestDepartment> {
        // Format managers to ensure they are sent as string IDs
        const formattedData = this.formatManagersForApi(data);
        return this.http.post<RequestDepartment>(this.baseUrl, formattedData);
    }

    updateRequestDepartment(id: string, data: UpdateRequestDepartmentDto): Observable<RequestDepartment> {
        // Format managers to ensure they are sent as string IDs
        const formattedData = this.formatManagersForApi(data);
        return this.http.patch<RequestDepartment>(`${this.baseUrl}/${id}`, formattedData);
    }

    deleteRequestDepartment(id: string): Observable<RequestDepartment> {
        return this.http.delete<RequestDepartment>(`${this.baseUrl}/${id}`);
    }

    // Helper method to format manager data for API requests
    private formatManagersForApi(data: CreateRequestDepartmentDto | UpdateRequestDepartmentDto): any {
        const formattedData = { ...data };

        // If managers exists and is an array, convert any objects to their ID strings
        if (formattedData.managers && Array.isArray(formattedData.managers)) {
            formattedData.managers = formattedData.managers
                .map((manager) => {
                    if (typeof manager === 'string') {
                        return manager;
                    }
                    if (manager && manager._id) {
                        return manager._id;
                    }
                    return '';
                })
                .filter((id) => id); // Filter out empty strings
        }

        return formattedData;
    }
}
